// Local top-10 leaderboard (Phase 6). Stored in SaveV2; an online board via
// api/leaderboard.php remains an explicit non-goal for now (plan stretch).

import type { SaveV2, LeaderboardEntry } from '@/save/schema';

export const LEADERBOARD_SIZE = 10;

export function qualifies(save: SaveV2, score: number): boolean {
  if (score <= 0) return false;
  if (save.leaderboard.length < LEADERBOARD_SIZE) return true;
  const last = save.leaderboard[save.leaderboard.length - 1];
  return last !== undefined && score > last.score;
}

/** Insert sorted by score, trimmed to the top 10. Returns the placement
 *  (1-based) or null if it didn't make the board. */
export function submit(save: SaveV2, entry: LeaderboardEntry): number | null {
  if (!qualifies(save, entry.score)) return null;
  save.leaderboard.push(entry);
  save.leaderboard.sort((a, b) => b.score - a.score);
  save.leaderboard.length = Math.min(save.leaderboard.length, LEADERBOARD_SIZE);
  const index = save.leaderboard.indexOf(entry);
  return index >= 0 ? index + 1 : null;
}

export function sanitizeInitials(raw: string): string {
  const cleaned = raw
    .toUpperCase()
    .replace(/[^A-Z0-9ÄÖÜ]/g, '')
    .slice(0, 3);
  return cleaned || 'AAA';
}
